import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { FILTER_GROUP_MODULES, FILTER_GROUP_MODULES_WITHOUT_OPTIONS } from '../constants/get_group_data.constants';
import { getGroupOptionsPermissions } from '../../requests/get_permissions_request';
import { getModelStructure } from '../../requests/get_model_structure_request';
import { getGroupOptionsPermissionsFailure, getGroupOptionsPermissionsSuccess } from '../actions/get_group_options_permissions.actions';
import { message_error } from '../../../../../components/Message';
import { proxy } from '../../components/statics';

function* filterGroupModuleRequest() {
    const { UserManagement: { User_group_update: { moduleOption, group_id, filteredModule } } } = yield select();
    const modelStructure = {};
    Object.defineProperty(modelStructure, 'size', {
        writable: true,
        enumerable: false,
        value: 0,
    });

    if (moduleOption.length) {
        if (moduleOption === 'models') {
            for (const model of filteredModule[moduleOption]) {
                const { options: { metadata } } = yield call(getModelStructure, model.modelName);
                modelStructure[metadata.URL] = metadata;
                modelStructure[metadata.URL].modulesPermissions = {
                    [metadata.URL]: {
                        url: metadata.URL,
                        permissions: [],
                    },
                };

                Object.defineProperty(modelStructure[metadata.URL].modulesPermissions, 'size', {
                    writable: true,
                    enumerable: false,
                    value: 1,
                });

                iterate_each_entity(modelStructure[metadata.URL].modulesPermissions, metadata.fields);
                modelStructure.size += modelStructure[metadata.URL].modulesPermissions.size;

                const { options } = yield call(getGroupOptionsPermissions, group_id, undefined, undefined, undefined, [{ entity: 'model', url: model.URL }, { entity: 'field', parent_entity_url: model.URL }]);

                options.forEach((perm) => {
                    if (modelStructure[metadata.URL].modulesPermissions[perm.url]) {
                        modelStructure[metadata.URL].modulesPermissions[perm.url] = perm;
                    }
                });
            }

            yield put(getGroupOptionsPermissionsSuccess(modelStructure));
        } else {
            let { result, options, error } = yield call(getGroupOptionsPermissions, group_id, proxy[moduleOption], filteredModule.URL);
            if (result) {
                options = filteredModule[moduleOption].map((m) => {
                    options.forEach(p => m.URL === p.url && Object.assign(m, { modulePermissions: p }));
                    return m;
                });
                yield put(getGroupOptionsPermissionsSuccess(options));
            } else {
                yield put(getGroupOptionsPermissionsFailure(error));
                message_error(error);
            }
        }
    } else {
        yield put({ type: FILTER_GROUP_MODULES_WITHOUT_OPTIONS });
    }
}

function iterate_each_entity(modulesPermissions, fields) {
    for (const key in fields) {
        if (fields.hasOwnProperty(key)) {
            modulesPermissions[fields[key].URL] = {
                url: fields[key].URL,
                permissions: [],
            };

            ++modulesPermissions.size;

            if (fields[key].childFields) {
                iterate_each_entity(modulesPermissions, fields[key].childFields);
            }
        }
    }
}

export default function* filterGroupModuleRequestSaga() {
    yield takeEvery(FILTER_GROUP_MODULES, filterGroupModuleRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/filter_group_module.saga.js